// CRIAR_RAPIDO_2810 (GROK2 28/10): modo "Cliente" da caixa Novo teste — cria cliente pago na hora,
// sem ir pra aba Clientes. Plano + 4/6/8 telas + Sem/Com adulto + app, custo em créditos e saldo antes→depois.
// Cria pela rota existente (/api/xui/lines via createLineFromPlan) com as mesmas travas de saldo do servidor.
// Switch: private/CRIAR_RAPIDO_2810_OFF. Valor (R$): VALOR_EDITAVEL_2810.
import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Check, Copy, Loader2, MessageCircle } from 'lucide-react';
import { API_BASE_URL } from '../apiBase';
import { formatApiError, useAuth } from '../context/AuthContext';
import { fmtCredits, planCreditQuote } from '../lib/planCreditPolicy';
import { formatPlanSelectLabel } from '../lib/planContentProfile';
import { createLineFromPlan } from '../lib/createLineFromPlan';
import { planPriceBRL2810, registrarVenda2810 } from '../lib/valorVenda2810';
import { sendAccessWhatsApp } from '../lib/sendAccessWhatsApp';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { cn } from '../lib/utils';
import AppLogo2810 from './AppLogo2810'; // APP_LOGO_2810
import { titleCase2810, planName2810 } from '../lib/displayCase2810'; // CASE_2810

const TELAS = [4, 6, 8];

export default function ClienteRapido2810({ apps, flags, onDone }) {
  const auth = useAuth();
  const [plans, setPlans] = useState(null);
  const [nome, setNome] = useState('');
  const [whats, setWhats] = useState('');
  const [sel, setSel] = useState('');
  const [telas, setTelas] = useState(4);
  const [adult, setAdult] = useState(false);
  const [appId, setAppId] = useState('');
  const [valor, setValor] = useState('');
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/xui/pricing/plans`, { withCredentials: true })
      .then(({ data }) => setPlans((data?.plans || []).filter((p) => !p.disabled && (p.xui_package_id || p.package_id)
        && ![true, 1, '1'].includes(p.is_trial) && planCreditQuote(p.credit_policy, p.credit_policy?.included_screens, 12))
        .sort((a, b) => (Number(a.sort_order) || 0) - (Number(b.sort_order) || 0))))
      .catch(() => setPlans([]));
  }, []);

  const plan = (plans || []).find((p) => String(p.id) === sel);
  const quote = plan ? planCreditQuote(plan.credit_policy, telas, 12) : null;
  const choice = !!plan?.content_choice_enabled;
  useEffect(() => { setValor(plan ? planPriceBRL2810(plan) : ''); }, [sel]); // eslint-disable-line react-hooks/exhaustive-deps
  const cred = auth?.accountSummary?.credits;
  const unlimited = !cred || cred.mode === 'unlimited';
  const saldo = Number(cred?.available ?? 0);
  const custo = quote?.totalCredits ?? null;
  const falta = !unlimited && custo != null && saldo < custo;
  const readyApps = useMemo(() => (apps || []).filter((a) => a.ready && a.id !== '__web_player__'), [apps]);
  const app = readyApps.find((a) => a.id === appId);

  const criar = async () => {
    if (busy || !plan || !quote || falta) return;
    setBusy(true);
    try {
      const data = await createLineFromPlan(API_BASE_URL, {
        planId: plan.id, nome: nome.trim(), whatsapp: whats, telas, isTrial: false,
        contentMode: choice ? (adult ? 'adult' : 'family') : '', partnerAppId: app?.id || '', creditPolicy: plan.credit_policy,
      });
      const line = data?.line || data || {};
      const username = line.username || data?.username || '';
      if (flags?.valor_editavel_2810 && valor) {
        try { await registrarVenda2810({ amount: valor, kind: 'create', username, lineId: line.id || data?.id, planLabel: plan.label, requestId: `new-${username}` }); }
        catch (_) { toast.error('Cliente criado, mas o valor não foi para o Financeiro.'); }
      }
      try { auth?.refreshAccountSummary?.(); } catch (_) { /* noop */ }
      setRes({ ...data, username, password: line.password || data?.password || '', exp: line.exp_date_formatted || data?.exp_date_formatted || '' });
      onDone?.();
    } catch (e) {
      toast.error(formatApiError(e?.response?.data?.detail) || 'Não foi possível criar o cliente.');
    } finally { setBusy(false); }
  };

  const seg = (on) => cn('h-10 flex-1 rounded-lg border text-sm font-semibold', on ? 'border-primary bg-primary text-primary-foreground' : 'bg-background hover:bg-muted');

  if (res) {
    const msg = String(res.template_msg || res.message || '').trim()
      || `Usuário: ${res.username}\nSenha: ${res.password}${res.exp ? `\nVencimento: ${res.exp}` : ''}`;
    return (
      <div className="space-y-3" data-cliente-rapido-2810>
        <div className="rounded-xl border border-emerald-500/40 bg-emerald-500/10 p-3 text-sm">
          <div>✅ Cliente criado · <b>{res.username}</b></div>
          <div>Senha: <b>{res.password}</b>{res.exp ? <> · vence {res.exp}</> : null}</div>
        </div>
        <pre className="max-h-48 overflow-auto whitespace-pre-wrap rounded-lg border bg-muted/40 p-2 text-xs">{msg}</pre>
        <div className="flex flex-wrap gap-2">
          <Button className="flex-1 gap-1" onClick={() => { navigator.clipboard?.writeText(msg); setCopied(true); }}>
            {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}{copied ? 'Copiado' : 'Copiar mensagem'}</Button>
          {whats.replace(/\D/g, '').length >= 10 ? (
            <Button variant="outline" className="flex-1 gap-1" onClick={async () => {
              const r = await sendAccessWhatsApp({ phone: whats, name: nome || res.username, message: msg });
              if (r?.ok) toast.success('Enviado no WhatsApp.'); else toast.error(r?.error || 'Não foi possível enviar.');
            }}><MessageCircle className="h-4 w-4" />Enviar WhatsApp</Button>
          ) : null}
        </div>
        <Button variant="ghost" className="w-full" onClick={() => { setRes(null); setSel(''); setNome(''); setWhats(''); setCopied(false); }}>Criar outro</Button>
      </div>
    );
  }

  return (
    <div className="space-y-3" data-cliente-rapido-2810>
      <div className="grid grid-cols-2 gap-2">
        <Input value={nome} onChange={(e) => setNome(e.target.value)} placeholder="Nome (opcional)" className="h-10" />
        <Input value={whats} onChange={(e) => setWhats(e.target.value)} placeholder="WhatsApp (opcional)" inputMode="tel" className="h-10" />
      </div>
      {plans === null ? <div className="flex items-center gap-2 text-sm text-muted-foreground"><Loader2 className="h-4 w-4 animate-spin" />Carregando planos…</div> : (
        <div className="divide-y overflow-hidden rounded-lg border" data-planos-lista-2810>
          {plans.map((p) => {
            const q = planCreditQuote(p.credit_policy, telas, 12);
            const on = sel === String(p.id);
            const preco = planPriceBRL2810(p);
            return (
              <button key={p.id} type="button" onClick={() => setSel(String(p.id))}
                className={cn('flex w-full items-center justify-between gap-2 px-3 py-2 text-left text-sm transition', on ? 'bg-primary/15 font-semibold text-primary' : 'hover:bg-muted')}>
                <span className="flex items-center gap-2"><span className={cn('h-3.5 w-3.5 rounded-full border-2', on ? 'border-primary bg-primary' : 'border-muted-foreground/40')} />{planName2810(p)}</span>
                <span className="whitespace-nowrap text-xs text-muted-foreground">{q ? `${fmtCredits(q.totalCredits)} créd.` : '—'}{preco ? ` · R$ ${preco}` : ''}</span>
              </button>
            );
          })}
        </div>
      )}
      <div className="flex items-center gap-2">
        <span className="w-12 text-sm font-medium">Telas</span>
        {TELAS.map((n) => <button key={n} type="button" onClick={() => setTelas(n)} className={cn(seg(telas === n), 'h-9')}>{n}</button>)}
      </div>
      <div className="flex gap-2">
        <button type="button" className={seg(!adult)} onClick={() => setAdult(false)}>Sem adulto</button>
        <button type="button" className={seg(adult)} onClick={() => setAdult(true)} disabled={plan ? !choice : false}>Com adulto</button>
      </div>
      {readyApps.length ? (
        <div className="grid grid-cols-4 gap-1.5 sm:grid-cols-5" data-app-logo2-2810>
          {readyApps.map((a) => (
            <button key={a.id} type="button" onClick={() => setAppId(appId === a.id ? '' : a.id)} title={titleCase2810(a.name)}
              className={cn('group flex min-w-0 flex-col items-center gap-1 rounded-xl border bg-card px-1 py-1.5 text-center shadow-sm transition hover:shadow-md', appId === a.id ? 'border-primary bg-primary/10 ring-2 ring-primary' : 'hover:bg-muted')}>
              <AppLogo2810 app={a} className="h-9 w-9 rounded-lg" textClass="text-[11px]" />
              <span className="line-clamp-2 w-full break-words text-[10px] font-semibold leading-tight">{titleCase2810(a.name || a.label || a.app_name)}</span>
            </button>
          ))}
        </div>
      ) : null}
      <div className="flex flex-wrap items-center justify-between gap-2 rounded-lg bg-muted/50 p-2 text-sm">
        {plan && quote ? (
          <span>{fmtCredits(custo)} crédito(s) · Saldo {unlimited ? <b>∞</b> : <><b>{fmtCredits(saldo)}</b> → <b className={falta ? 'text-destructive' : ''}>{fmtCredits(saldo - custo)}</b></>}{falta ? <b className="text-destructive"> · saldo insuficiente</b> : null}</span>
        ) : <span className="text-muted-foreground">Escolha o plano.</span>}
        {flags?.valor_editavel_2810 && plan ? (
          <label className="flex items-center gap-1"><span className="text-xs font-medium">R$</span>
            <Input value={valor} onChange={(e) => setValor(e.target.value.replace(/[^\d,.]/g, ''))} inputMode="decimal" placeholder="0,00" className="h-8 w-20" data-valor-2810 /></label>
        ) : null}
      </div>
      <Button onClick={criar} disabled={!plan || !quote || busy || falta} className="h-12 w-full text-base font-semibold">
        {busy ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" />Criando…</> : 'Criar cliente'}
      </Button>
    </div>
  );
}
